// import React from 'react'
// import "./bannerSection.css"
// import Form from 'react-bootstrap/Form';


// const BannerSection = () => {
//     return (
//         <>
//             <section className="bannerSection">
//                 <div className="container-fluid containerSpacing">
//                     <div className="row">
//                         <div className="col-lg-6 col-md-6 col-12">
//                             <div className="banner-content">
//                                 <h1>
//                                     ALL-IN-ONE HR system for managing employee aﬀairs in the United Arab Emirates
//                                 </h1>
//                                 <p>
//                                     HR PASS is a comprehensive pla orm enables you to organize the
//                                     company’s ﬁles, manage employee aﬀairs, and calculate salaries
//                                     following the laws and requirements of the Ministry of Human
//                                     Resources and Emira sa on in the country.
//                                 </p>
//                                 <p>
//                                     HR PASS pla orm is designed to streamline various HR func ons while
//                                     ensuring compliance with local labor laws
//                                 </p>

//                                 <div className="customFrom">
//                                     <Form>
//                                         <Form.Group className="mb-5" controlId="exampleForm.ControlInput1">
//                                             <Form.Label>E-mail</Form.Label>
//                                             <Form.Control type="email" placeholder="emailemail@gmail.com" />
//                                         </Form.Group>
//                                     </Form>
//                                 </div>

//                                 <a href='' className='darkBrownBtn'>
//                                     GET A FREE DEMO
//                                 </a>
//                             </div>
//                         </div>
//                         <div className="col-lg-6 col-md-6 col-12">

//                         </div>
//                     </div>
//                 </div>
//             </section>
//         </>
//     )
// }
// export default BannerSection;


// import React from "react";
// import { Swiper, SwiperSlide } from "swiper/react";
// import "swiper/swiper-bundle.css"; // Import Swiper styles
// import "./bannerSection.css";
// import Form from "react-bootstrap/Form";
// import MainImg from "../../assets/images/Main-Photo.png";

// const BannerSection = ({ isRtl }) => {
//     // Content translations
//     const content = isRtl
//         ? {
//             heading: "نظام متكامل لإدارة الموارد البشرية و شؤون الموظفين في دولة الإمارات العربية المتحدة",
//             paragraph1: "تمكنك منصة اتش ار باس من تنظيم ملفات المنشأة وإدارة شؤون الموظفين وحساب الرواتب بالتوافق مع قوانين و اشتراطات وزارة الموارد البشرية والتوطين  في الدولة.",
//             // paragraph2: "صممت منصة HR PASS لتبسيط وظائف الموارد البشرية المختلفة مع ضمان الامتثال لقوانين العمل المحلية.",
//             emailLabel: "البريد الالكتروني",
//             emailPlaceholder: "email@gmail.com",
//             buttonText: "اطلب عرض تجريبي",
//         }
//         : {
//             heading: "ALL-IN-ONE HR system for managing employee affairs in the United Arab Emirates",
//             paragraph1:
//                 "HR PASS is a comprehensive platform that enables you to organize the company’s files, manage employee affairs, and calculate salaries following the laws and requirements of the Ministry of Human Resources and Emiratisation in the country.",
//             paragraph2: "HR PASS platform is designed to streamline various HR functions while ensuring compliance with local labor laws.",
//             emailLabel: "E-mail",
//             emailPlaceholder: "email@gmail.com",
//             buttonText: "GET A FREE DEMO",
//         };

//     const slide2 = isRtl
//         ? {
//             heading: "نظام حساب الرواتب موثق تلقائياً وفقاً للنظام المعتمد في المنشأة.",
//             paragraph1: "لا حاجة للعودة إلى الحسابات اليدوية وجداول البيانات وملفات الإكسل المعقدة وغير المعتمدة.مع نظام HR PASS ،  احصل على تقارير حماية الأجـور وملفـاتSIF  تلقائياً، وفقاً للقـوانين المتبعة في دولـة الإمارات العربية المتحدة",
//             emailLabel: "البريد الإلكتروني",
//             emailPlaceholder: "email@gmail.com",
//             buttonText: "اطلب عرض تجريبي",
//         }
//         : {
//             heading: "ALL-IN-ONE HR system for managing employee affairs in the United Arab Emirates",
//             paragraph1: "HR PASS is a comprehensive platform that enables you to organize the company’s files, manage employee affairs, and calculate salaries following the laws and requirements of the Ministry of Human Resources and Emiratisation in the country.",
//             paragraph2: "HR PASS platform is designed to streamline various HR functions while ensuring compliance with local labor laws.",
//             emailLabel: "E-mail",
//             emailPlaceholder: "emailemail@gmail.com",
//             buttonText: "GET A FREE DEMO",
//         };

//     const slide3 = isRtl
//         ? {
//             heading: "HR PASS تلبي جميع الخدمات الحكومية للمنشآت و الموظفين",
//             paragraph1: "لا مزيد من المعاناة في تخليص المعاملات ومتابعتها، مع توفير جميع الأوراق الرسمية المطلوبة للمنشآت والموظفين بكل سهولة ",
//             emailLabel: "البريد الإلكتروني",
//             emailPlaceholder: "email@gmail.com",
//             buttonText: "اطلب عرض تجريبي",
//         }
//         : {
//             heading: "ALL-IN-ONE HR system for managing employee affairs in the United Arab Emirates",
//             paragraph1:
//                 "HR PASS is a comprehensive platform that enables you to organize the company’s files, manage employee affairs, and calculate salaries following the laws and requirements of the Ministry of Human Resources and Emiratisation in the country.",
//             paragraph2: "HR PASS platform is designed to streamline various HR functions while ensuring compliance with local labor laws.",
//             emailLabel: "E-mail",
//             emailPlaceholder: "emailemail@gmail.com",
//             buttonText: "GET A FREE DEMO",
//         };

//     return (
//         <section className={`bannerSection ${isRtl ? "rtl" : ""}`}>
//             <div className="">
//                 <Swiper
//                     key={isRtl ? "rtl" : "ltr"}
//                     spaceBetween={30}
//                     slidesPerView={1}
//                     autoplay={{
//                         delay: 3000,
//                         disableOnInteraction: false,
//                     }}
//                     loop={true}
//                 >
//                     <SwiperSlide>
//                         <div className="row align-items-center">
//                             <div className="col-lg-5 col-md-6 col-12" data-aos-easing="ease-in-out" data-aos="fade-right">
//                                 <div className="banner-content">
//                                     <h1>{content.heading}</h1>
//                                     <p>{content.paragraph1}</p>
//                                     <p>{content.paragraph2}</p>

//                                     <div className="customFrom">
//                                         <Form>
//                                             <Form.Group className="mb-5" controlId="exampleForm.ControlInput1">
//                                                 <Form.Label>{content.emailLabel}</Form.Label>
//                                                 <Form.Control type="email" placeholder={content.emailPlaceholder} />
//                                             </Form.Group>
//                                         </Form>
//                                     </div>

//                                     <a href="" className="darkBrownBtn">
//                                         {content.buttonText}
//                                     </a>
//                                 </div>
//                             </div>
//                             <div className="col-lg-7 col-md-6 col-12" data-aos-easing="ease-in-out" data-aos="fade-left">
//                                 <div className="banner-img">
//                                     <img src={MainImg} alt="" />
//                                 </div>
//                             </div>
//                         </div>
//                     </SwiperSlide>
//                     <SwiperSlide>
//                         <div className="row align-items-center">
//                             <div className="col-lg-5 col-md-6 col-12" data-aos-easing="ease-in-out" data-aos="fade-right">
//                                 <div className="banner-content">
//                                     <h1>{slide2.heading}</h1>
//                                     <p>{slide2.paragraph1}</p>
//                                     <p>{slide2.paragraph2}</p>

//                                     <div className="customFrom">
//                                         <Form>
//                                             <Form.Group className="mb-5" controlId="exampleForm.ControlInput1">
//                                                 <Form.Label>{slide2.emailLabel}</Form.Label>
//                                                 <Form.Control type="email" placeholder={slide2.emailPlaceholder} />
//                                             </Form.Group>
//                                         </Form>
//                                     </div>

//                                     <a href="" className="darkBrownBtn">
//                                         {slide2.buttonText}
//                                     </a>
//                                 </div>
//                             </div>
//                             <div className="col-lg-7 col-md-6 col-12" data-aos-easing="ease-in-out" data-aos="fade-left">
//                                 <div className="banner-img">
//                                     <img src={MainImg} alt="" />
//                                 </div>
//                             </div>
//                         </div>
//                     </SwiperSlide>
//                     <SwiperSlide>
//                         <div className="row align-items-center">
//                             <div className="col-lg-5 col-md-6 col-12" data-aos-easing="ease-in-out" data-aos="fade-right">
//                                 <div className="banner-content">
//                                     <h1>{slide3.heading}</h1>
//                                     <p>{slide3.paragraph1}</p>
//                                     <p>{slide3.paragraph2}</p>

//                                     <div className="customFrom">
//                                         <Form>
//                                             <Form.Group className="mb-5" controlId="exampleForm.ControlInput1">
//                                                 <Form.Label>{slide3.emailLabel}</Form.Label>
//                                                 <Form.Control type="email" placeholder={slide3.emailPlaceholder} />
//                                             </Form.Group>
//                                         </Form>
//                                     </div>

//                                     <a href="" className="darkBrownBtn">
//                                         {slide3.buttonText}
//                                     </a>
//                                 </div>
//                             </div>
//                             <div className="col-lg-7 col-md-6 col-12" data-aos-easing="ease-in-out" data-aos="fade-left">
//                                 <div className="banner-img">
//                                     <img src={MainImg} alt="" />
//                                 </div>
//                             </div>
//                         </div>
//                     </SwiperSlide>
//                 </Swiper>
//             </div>
//         </section>
//     );
// };

// export default BannerSection;



import React, { useEffect, useRef } from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/swiper-bundle.css"; // Import Swiper styles
import "./bannerSection.css";
import Form from "react-bootstrap/Form";
import MainImg from "../../assets/images/Main-Photo.png";
import FormModal from "../formModal/FormModal";

const BannerSection = ({ isRtl }) => {
    const swiperRef = useRef(null);

    const content = isRtl
        ? {
            heading: "نظام متكامل لإدارة الموارد البشرية و شؤون الموظفين في دولة الإمارات العربية المتحدة",
            paragraph1:
                "تمكنك منصة اتش ار باس من تنظيم ملفات المنشأة وإدارة شؤون الموظفين وحساب الرواتب بالتوافق مع قوانين و اشتراطات وزارة الموارد البشرية والتوطين  في الدولة.",
            emailLabel: "البريد الالكتروني",
            emailPlaceholder: "email@gmail.com",
            buttonText: "اطلب عرض تجريبي",
        }
        : {
            heading: "ALL-IN-ONE HR system for managing employee affairs in the United Arab Emirates",
            paragraph1:
                "HR PASS is a comprehensive platform that enables you to organize the company’s files, manage employee affairs, and calculate salaries following the laws and requirements of the Ministry of Human Resources and Emiratisation in the country.",
            paragraph2: "HR PASS platform is designed to streamline various HR functions while ensuring compliance with local labor laws.",
            emailLabel: "E-mail",
            emailPlaceholder: "email@gmail.com",
            buttonText: "GET A FREE DEMO",
        };

    const slide2 = isRtl
        ? {
            heading: "نظام حساب الرواتب موثق تلقائياً وفقاً للنظام المعتمد في المنشأة.",
            paragraph1:
                "لا حاجة للعودة إلى الحسابات اليدوية وجداول البيانات وملفات الإكسل المعقدة وغير المعتمدة.مع نظام HR PASS ،  احصل على تقارير حماية الأجـور وملفـاتSIF  تلقائياً، وفقاً للقـوانين المتبعة في دولـة الإمارات العربية المتحدة",
            emailLabel: "البريد الإلكتروني",
            emailPlaceholder: "email@gmail.com",
            buttonText: "اطلب عرض تجريبي",
        }
        : {
            heading: "ALL-IN-ONE HR system for managing employee affairs in the United Arab Emirates",
            paragraph1:
                "HR PASS is a comprehensive platform that enables you to organize the company’s files, manage employee affairs, and calculate salaries following the laws and requirements of the Ministry of Human Resources and Emiratisation in the country.",
            emailLabel: "E-mail",
            emailPlaceholder: "emailemail@gmail.com",
            buttonText: "GET A FREE DEMO",
        };

    const slide3 = isRtl
        ? {
            heading: "HR PASS تلبي جميع الخدمات الحكومية للمنشآت و الموظفين",
            paragraph1:
                "لا مزيد من المعاناة في تخليص المعاملات ومتابعتها، مع توفير جميع الأوراق الرسمية المطلوبة للمنشآت والموظفين بكل سهولة ",
            emailLabel: "البريد الإلكتروني",
            emailPlaceholder: "email@gmail.com",
            buttonText: "اطلب عرض تجريبي",
        }
        : {
            heading: "ALL-IN-ONE HR system for managing employee affairs in the United Arab Emirates",
            paragraph1:
                "HR PASS is a comprehensive platform that enables you to organize the company’s files, manage employee affairs, and calculate salaries following the laws and requirements of the Ministry of Human Resources and Emiratisation in the country.",
            emailLabel: "E-mail",
            emailPlaceholder: "emailemail@gmail.com",
            buttonText: "GET A FREE DEMO",
        };

    useEffect(() => {
        const swiper = swiperRef.current?.swiper;

        const addZoomAnimation = () => {
            const activeSlide = swiper.slides[swiper.activeIndex];
            const img = activeSlide.querySelector("img");
            if (img) {
                img.classList.remove("zoom-in");
                void img.offsetWidth; // Trigger reflow to restart animation
                img.classList.add("zoom-in");
            }
        };

        if (swiper) {
            swiper.on("slideChange", addZoomAnimation);
            swiper.on("init", addZoomAnimation);
        }

        return () => {
            if (swiper) {
                swiper.off("slideChange", addZoomAnimation);
                swiper.off("init", addZoomAnimation);
            }
        };
    }, []);

    return (
        <section className={`bannerSection ${isRtl ? "rtl" : ""}`}>
            <div>
                <Swiper
                    ref={swiperRef}
                    key={isRtl ? "rtl" : "ltr"}
                    spaceBetween={30}
                    slidesPerView={1}
                    autoplay={{
                        delay: 3000,
                        disableOnInteraction: false,
                    }}
                    loop={true}
                >
                    {[content, slide2, slide3].map((slide, index) => (
                        <SwiperSlide key={index}>
                            <div className="row align-items-center">
                                <div className="col-lg-5 col-md-6 col-12">
                                    <div className="banner-content">
                                        <h1>{slide.heading}</h1>
                                        <p>{slide.paragraph1}</p>
                                        <p>{slide.paragraph2}</p>
                                        <div className="customFrom">
                                            <Form>
                                                <Form.Group className="mb-5" controlId={`email-${index}`}>
                                                    <Form.Label>{slide.emailLabel}</Form.Label>
                                                    <Form.Control type="email" placeholder={slide.emailPlaceholder} />
                                                </Form.Group>
                                            </Form>
                                        </div>
                                        {/* <a href="" className="darkBrownBtn">
                                            {slide.buttonText}
                                        </a> */}
                                        <FormModal isRtl={isRtl} />
                                    </div>
                                </div>
                                <div className="col-lg-7 col-md-6 col-12">
                                    <div className="banner-img">
                                        <img src={MainImg} alt={`Slide ${index}`} />
                                    </div>
                                </div>
                            </div>
                        </SwiperSlide>
                    ))}
                </Swiper>
            </div>
        </section>
    );
};

export default BannerSection;
